window.addEventListener("load", function () {

    if ($('#MS__wrapper.iframe').length > 0) return;

    let mainSwiper, thumbSwiper;

    // Data & small helpers
    const $characterSection = $('#nth-ld-25-ld-characters');
    const texts = $characterSection.find('.swiper-characters .swiper-slide').map(function () {
        const textFromData = ($(this).attr('data-slide') || '').trim();
        if (textFromData) return textFromData;
        return ($(this).find('.btn-video').attr('aria-label') || '').trim();
    }).get().filter(Boolean);

    $characterSection.find('.swiper-characters .swiper-slide').each(function () {
        const $slide = $(this);
        const $btnVideo = $slide.find('.btn-video');
        if (!$btnVideo.length) return;

        const linkFromData = ($slide.attr('data-video') || '').trim();
        const linkFromHref = ($btnVideo.attr('href') || '').trim();
        const videoLink = linkFromData || linkFromHref;

        if (videoLink) {
            $btnVideo.attr('href', videoLink);
            $btnVideo.attr('data-fancybox', '');
        } else {
            $btnVideo.removeAttr('href');
            $btnVideo.removeAttr('data-fancybox');
        }
    });

    const isPC = $('body').data('device-type') === 'desktop';
    const getIndex = (swiper) => {
        if (!swiper) return undefined;
        return (typeof swiper.realIndex === 'number') ? swiper.realIndex : swiper.activeIndex;
    };
    const renderBullet = (index, className) => {
        const text = texts[index] || '•';
        return `<span class="pagi-dot MS__NTH_Justice_Mist stt-${index + 1} ${className}">${text}</span>`;
    };
    const slideToSafe = (swiper, idx, preferLoop = false) => {
        if (typeof idx !== 'number' || Number.isNaN(idx) || !swiper) return;
        if (preferLoop && typeof swiper.slideToLoop === 'function') return swiper.slideToLoop(idx);
        return swiper.slideTo(idx);
    };

    if (isPC) {
        // Desktop: single main swiper, loop + fade, no thumbs
        mainSwiper = new Swiper(".swiper-characters", {
            effect: "fade",
            loop: true,
            touchRatio: 0,
            // mousewheel: {
            //     forceToAxis: true,       // chỉ ăn theo trục ngang/dọc đúng ý
            //     sensitivity: 0.4,        // giảm nhạy (thấp hơn = khó nhảy nhiều)
            //     thresholdDelta: 40,      // bỏ qua cuộn nhỏ lặt vặt
            //     thresholdTime: 300,      // gộp loạt sự kiện trong 300ms thành 1 lần
            //     releaseOnEdges: true,    // thả cho trang cuộn khi ở mép
            // },
            pagination: {
                el: ".swiper-characters-pagination",
                clickable: true,
                renderBullet,
            },
        });
    } else {
        // Mobile: thumbs + main, both non-loop to keep indices aligned
        thumbSwiper = new Swiper(".swiper-characters-thumb", {
            slidesPerView: 5,
            loop: false, // avoid index mismatch
            centeredSlides: true,
        });

        mainSwiper = new Swiper(".swiper-characters", {
            effect: "fade",
            fadeEffect: {
                crossFade: true,
            },
            loop: false, // align indices with thumbs
            allowTouchMove: true,
            touchRatio: 1,
            simulateTouch: true,
            grabCursor: true,
            threshold: 8, // avoid accidental tiny swipes
            pagination: {
                el: ".swiper-characters-pagination",
                clickable: true,
                renderBullet,
            },
            // Keep for auto-sync when Thumbs module is active in some builds
            thumbs: { swiper: thumbSwiper },
        });

        // Robust manual syncing between thumb and main
        thumbSwiper.on('slideChange', function () {
            const i = getIndex(thumbSwiper);
            if (getIndex(mainSwiper) !== i) slideToSafe(mainSwiper, i);
        });

        thumbSwiper.on('click', function () {
            const slideEl = thumbSwiper.clickedSlide;
            if (!slideEl) return;
            const realAttr = slideEl.getAttribute && slideEl.getAttribute('data-swiper-slide-index');
            const i = (realAttr !== null && realAttr !== undefined)
                ? parseInt(realAttr, 10)
                : thumbSwiper.clickedIndex;
            slideToSafe(mainSwiper, i);
        });

        mainSwiper.on('slideChange', function () {
            const i = getIndex(mainSwiper);
            const tIndex = getIndex(thumbSwiper);
            if (tIndex !== i) slideToSafe(thumbSwiper, i, true);
        });
    }
});
